<template>
   <div class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2" style="height: inherit; width:inherit;">
    <!-- Content Header (Page header) -->
        <!-- <div v-if="$gate.isBranchManager()"> -->
<!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->

    <section class="content-header">
        <div class="container-fluid">
          <div class="row mb-2">
            <div class="col-sm-6">
              <h2>{{ $route.meta.title }}</h2>
            </div>
            <div class="col-sm-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item"><a href="/home">Home</a></li>
                <li class="breadcrumb-item active">{{ $route.meta.title }}</li>
              </ol>
            </div>
          </div>
        </div><!-- /.container-fluid -->
      </section>





<!--      <span class="pull-right">-->
<!--            &lt;!&ndash; <a href="javascript:;" class="btn btn-sm btn-white m-b-10 p-l-5"><i class="fa fa-file t-plus-1 text-danger fa-fw fa-lg"></i> Export as PDF</a> &ndash;&gt;-->
<!--            <a href="javascript:;" onclick="window.print()" class="btn btn-sm btn-white m-b-10 p-l-5 d-print-none"><i class="fa fa-print t-plus-1 fa-fw fa-lg"></i> Print</a>-->
<!--            &lt;!&ndash; <a href="javascript:;" @click="print" class="btn btn-sm btn-white m-b-10 p-l-5"><i class="fa fa-print t-plus-1 fa-fw fa-lg"></i> Print in a New Page</a> &ndash;&gt;-->
<!--            </span>-->
            <br>
            <br>
    <!-- Main content -->
    <section class="content" >
      <div class="container">
   <div class="col-md-12">


      <div class="invoice" id="print">
         <div class="col-md-12">
            <!-- begin invoice-company -->
         <div class="invoice-company">
            <div class="row">
                <div class="col-sm-12">
                    <div class="row f-w-600">
                        <div class="col-sm-9">
                          <div class="invoice-from">
                            <!-- <small class="m-r-10" style="font-height:8px !important;">
                            {{ branch.address_line_1 }}
                            {{ branch.address_line_2 }}
                            {{ branch.address_line_3 }}
                            {{ branch.city }} {{ branch.state }} {{ branch.country }}
                            Email: {{ branch.email }} | Phone: {{ branch.alt_phone }}
                           </small> -->
                          </div>
                        </div>
                <div class="col-sm-3" align="right">
                    <h2>{{ order.branch_code }}</h2>
                </div>
                    </div>
                </div>
              </div>
            <div class="row justify-content-center " align="center">
               <h3>Sale Order</h3>
            </div>
         </div>
         <!-- end invoice-company -->
         <!-- begin invoice-header -->
         <div class="invoice-header">
            <div class="invoice-from">
               <small>Customer | BILLING ADDRESS</small>
               <address class="m-t-5 m-b-5">
                  <strong class="text-inverse">{{ order.customer_name }}</strong><br>
                  {{ order.bill_address }}<br>
                  {{ order.bill_building }}<br>
                  {{ order.bill_street }}<br>
                  {{ order.bill_block }}<br>
                  {{ order.bill_city }} {{ order.bill_zip_code }}, {{ order.bill_state }}, {{ order.bill_country }}
                  <br>
                  <!-- Phone: (123) 456-7890<br>
                  Fax: (123) 456-7890 -->
               </address>
            </div>
            <div class="invoice-to">
               <small>Customer | SHIPPING ADDRESS</small>
               <address class="m-t-5 m-b-5">
                  <strong class="text-inverse">{{ order.customer_name }}</strong><br>
                  {{ order.ship_address }}<br>
                  {{ order.ship_building }}<br>
                  {{ order.ship_street }}<br>
                  {{ order.ship_block }}<br>
                  {{ order.ship_city }} {{ order.ship_zip_code }}, {{ order.ship_state }}, {{ order.ship_country }}
                  <br>
                  <!-- Phone: (123) 456-7890<br>
                  Fax: (123) 456-7890 -->
               </address>
            </div>
            <div class="invoice-date">
               <small>SALE ORDER</small>
               <div class="date text-inverse m-t-5">Issue Date: {{order.updated_at | issueDate}}</div>
               <div class="invoice-detail">
                  SO # {{ order.branch_code }} / {{order.sap_doc_num}}<br>
                  Ref# {{ order.gatepass_id }} / {{ order.id }}
                  <br>
                  <br>
                  <qrcode-vue :value="value" :size="size" level="H" />
               </div>
            </div>
         </div>
         <!-- end invoice-header -->
         <!-- begin invoice-content -->
         <div class="invoice-content">
            <!-- begin table-responsive -->
            <div class="table-responsive">
               <table class="table table-invoice">
                  <thead>
                     <tr>
                        <th class="text-center" width="30%">Item</th>
                        <th class="text-center" width="5%">Quantity</th>
                        <!-- <th class="text-center" width="10%">UnitPrice</th> -->
                        <th class="text-right" width="15%">Taxable Amount</th>
                        <th class="text-center" width="5%">Discount</th>
                        <th class="text-center" width="5%">CGST</th>
                        <th class="text-center" width="5%">SGST</th>
                        <th class="text-center" width="5%">IGST</th>
                        <th class="text-center" width="5%">Tax Total</th>
                        <th class="text-right" width="15%">Item Sub-Total</th>
                     </tr>
                  </thead>
                  <tbody>
                     <tr v-for="i in items" :key="i.id">
                        <td>
                           <span class="text-inverse">{{i.item_name}}</span>
                           <br>
                           <span class="text-inverse">{{i.serial}}</span>
                           </td>
                        <td class="text-center">{{i.order_quantity}}</td>
                        <td class="text-center">{{i.taxable_amount | dotNumbers}}</td>
                        <td class="text-center">{{i.discount_amount | dotNumbers}}</td>
                        <td class="text-center">{{i.cgst_amount | dotNumbers}} <br> {{ i.cgst_perc | dotNumbers}}%</td>
                        <td class="text-center">{{i.sgst_amount | dotNumbers}} <br> {{ i.sgst_perc | dotNumbers}}%</td>
                        <td class="text-center">{{i.igst_amount | dotNumbers}} <br> {{ i.igst_perc | dotNumbers}}%</td>
                        <td class="text-center">{{i.tax_total_amount | dotNumbers}} <br> {{i.tax_rate | dotNumbers}}%</td>
                        <td class="text-center">{{i.bill_price | dotNumbers}}</td>
                        <td class="text-right"></td>
                     </tr>


                  </tbody>
               </table>
            </div>
            <!-- end table-responsive -->
            <!-- begin invoice-price -->
            <div class="invoice-price">
               <div class="invoice-price-left">
                  <div class="invoice-price-row">
                     <div class="sub-price">
                        <small>SUBTOTAL</small>
                        <span class="text-inverse">INR {{order.taxable_amount | dotNumbers}}</span>
                     </div>
                     <div class="sub-price">
                        <i class="fa fa-plus text-muted"></i>
                     </div>
                     <div class="sub-price">
                        <small>TAX</small>
                        <span class="text-inverse">INR {{order.sap_tax_sum | dotNumbers}}</span>
                     </div>
                  </div>
               </div>
               <div class="invoice-price-right">
                  <small>TOTAL</small> <span class="f-w-600">INR {{ order.sap_doc_total }} </span>
               </div>
            </div>
            <!-- end invoice-price -->
         </div>

      <br>

         <div class="invoice-content col-md-12">
            <div class="row">
               <div class="col-md-12">
                  <div class="row">
                     <div class="col-md-3">
                        <p>Total Amount in Words: </p>
                     </div>
                     <div class="col-md-9">
                        <h5> {{order.sap_doc_total | toWords}} INR ONLY</h5>
                     </div>
                  </div>
                  <div class="row">
                     <div class="col-md-3">
                        <p>Remarks:</p>
                     </div>
                     <div class="col-md-9">
                        <h5>{{ order.remarks }}</h5>
                     </div>
                  </div>
               </div>
            </div>
         </div>
         <!-- end invoice-content -->
         <!-- begin invoice-note -->
         <div class="col-md-12">
            <div class="row">
               <!-- <div class="col-md-6">
                  <qrcode-vue :value="value" :size="size" level="H" />
               </div> -->
              <div class="col-md-12">
                  <div class="invoice-note">
                     * Make all cheques payable to OXYGEN THE DIGITAL SHOP,<br>South Indian Bank<br>
                     Branch: Nagampadom , Account: 0498083000000035, IFSC: SIBL0000498
                     <br>
            * Payment is due within 30 days<br>
            * If you have any questions concerning this invoice, contact us at support@oxygendigitalshop.com , issues@oxygendigitalshop.com or 9020-100-100
         </div>
               </div>


            </div>
         </div>
         <!-- end invoice-note -->
         <!-- begin invoice-footer -->
         <div class="invoice-footer">
            <div class="col-md-12">
               <div class="row">

                  <div class="col-md-12">
                     <p class="text-center m-b-5 f-w-600">
               THANK YOU FOR YOUR BUSINESS
            </p>

            <p class="text-center">
               <span class="m-r-10"><i class="fa fa-fw fa-lg fa-globe"></i> oxygendigitalshop.com</span>
               <span class="m-r-10"><i class="fa fa-fw fa-lg fa-phone-volume"></i> T: 9020-100-100</span>
               <span class="m-r-10"><i class="fa fa-fw fa-lg fa-envelope"></i> support@oxygendigitalshop.com</span>
               <span class="m-r-10"><i class="fa fa-fw fa-lg fa-envelope"></i> issues@oxygendigitalshop.com</span>
            </p>

                  </div>
               </div>
            </div>


         </div>
         <!-- end invoice-footer -->
         <br>
         <br>
         </div>
      </div>
   </div>
   <br>
   <br>
   <br>
   <br>
   <br>
</div>

<!-- row end -->
    </section>
    <!-- /.content -->
<!-- All VUE Parts end before this comment -->
        <!-- </div> -->
        <!-- <div v-if="!$gate.isBranchManager()">
             <access-denied></access-denied>
        </div> -->
    </div>
</template>

<script>
        import QrcodeVue from 'qrcode.vue/dist/qrcode.vue'

		 export default {
        mounted() {
            console.log('Component mounted.')
        },

        created(){
        	this.getOrder();
        	//this.getReceipt();
        	//this.getCollectedPayments();
        },

        data(){
        	return {
        		order: {},
        		items: [],
        		branch: {},
                name: '',
                value: 'www.oxygendigitalshop.com',
                size: 250,
                receipts: [],
                collected_payments: []
        	}
        },

        components: {
            QrcodeVue,
            },

        methods: {
        	getOrder(){
        		axios.post("/api/getDraftOrder", {id: this.$route.params.order_id})
        		.then(response => {
        			this.order = response.data.order;
        			this.items = response.data.items;
        			this.branch = response.data.branch;
        			this.getReceipt();
        			this.getCollectedPayments();
        		})
        	},

        	getReceipt(){
        		axios.post("/api/getReceipts", {gatepass: this.order.gatepass_id})
        		.then(response => {
        			this.receipts = response.data.receipts;
        		})
        	},

        	getCollectedPayments(){
        		axios.post("/api/getOrderPayments", {gatepass: this.order.gatepass_id})
        		.then(response => {
        			this.collected_payments = response.data.collected_payments;
        		})
        	},
        }
    }
</script>
<style>
    .header{
        position:sticky;
        top: 0 ;
    }
</style>
